import { buildClaimExplanationPacket, type ClaimExplanationPacket } from './explainability.js';
import { extractRelationshipFeatures, type RelationshipContextBundle } from './relationshipContext.js';
import type { GeneratedRelationshipReport, RelationshipClaim } from './relationshipInterpretation.js';

export interface RelationshipClaimExplanationPacket extends ClaimExplanationPacket {
  relationshipType: RelationshipContextBundle['relationshipType'];
  mappingLabel: string;
}

export function buildRelationshipClaimExplanationPacket(
  context: RelationshipContextBundle,
  claim: RelationshipClaim,
): RelationshipClaimExplanationPacket {
  const base = buildClaimExplanationPacket(claim, extractRelationshipFeatures(context));
  return Object.freeze({
    ...base,
    relationshipType: context.relationshipType,
    mappingLabel: context.mapping.directionLabel,
  });
}

export function buildRelationshipReportExplanationPackets(
  context: RelationshipContextBundle,
  report: GeneratedRelationshipReport,
): readonly RelationshipClaimExplanationPacket[] {
  if (context.contextFingerprint !== report.contextFingerprint) {
    throw new Error('Relationship explanation rejected report from a different context');
  }
  if (context.relationshipType !== report.relationshipType) {
    throw new Error('Relationship explanation rejected report with a different relationship type');
  }
  return Object.freeze(report.topics[0].claims.map((claim) => buildRelationshipClaimExplanationPacket(context, claim)));
}
